import { IBaseEntity } from './base-entity.interface';
import { PermissionConditionRule } from './permission-condition.interface';

export interface IRole extends IBaseEntity {
  name: string;
  description: string;
  usersCount?: number;
  permissions: IPermission[];
  redirectAreaId?: string | null;
}

export interface IPermission extends IBaseEntity {
  effect: PermissionEffect;
  action: PermissionAction;
  collection: string;
  fields: string[];
  conditions?: IPermissionCondition[];
  role?: IRole;
  roleId?: string;
}

export interface IPermissionCondition {
  id?: string;
  propertyName: string;
  propertyValue: string;
  rule: PermissionConditionRule;
  permission?: IPermission;
  permissionId?: string;
}

export enum PermissionAction {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  READ = 'READ',
  MANAGE = 'MANAGE'
}

export enum PermissionEffect {
  ALLOW = 'ALLOW',
  DENY = 'DENY'
}

export interface ICollectionField {
  name: string;
  type: ICollectionFieldPropertyType;
  isRequired: boolean;
  isList: boolean;
  kind: string;
  relationName?: string;
  supportedRules: PermissionConditionRule[];
}

export interface ICollectionMetadata {
  name: string;
  fields: ICollectionField[];
}

export interface ICollectionsMetadata {
  collections: ICollectionMetadata[];
}

export enum ICollectionFieldPropertyType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  DATETIME = 'DATETIME',
  RELATION = 'RELATION'
}

export interface ICreateRoleInput {
  name: string;
  description?: string;
  roleTemplateId?: string;
  permissions?: IPermission[];
  redirectAreaId?: string;
}

export interface IUpdateRolePermissionCondition {
  id?: string;
  propertyName: string;
  propertyValue: string;
  rule: PermissionConditionRule;
}

export interface IUpdateRolePermission {
  id?: string;
  effect: PermissionEffect;
  action: PermissionAction;
  collection: string;
  fields?: string[];
  conditions: IUpdateRolePermissionCondition[];
}

export interface IUpdateRoleInput {
  name: string;
  description: string;
  permissions: IUpdateRolePermission[];
  redirectAreaId?: string | null;
}

export interface IRoleTemplate {
  id: string;
  name: string;
  description: string;
  icon: string;
  permissions: IPermission[];
}
